import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { LanguageContext } from "../context/LanguageContext";
import FAQ from "../components/FAQ/FAQ";

const CmsPage = () => {
  const { slug } = useParams();
  const { language, t } = useContext(LanguageContext);
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false); // reset state on slug/language change
    setPage(null);

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/cms/${slug}?lang=${language.toLowerCase()}`)
      .then((res) => {
        setPage(res.data);
      })
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          setNotFound(true);
        } else {
          console.error("CMS fetch error:", err);
        }
      });
  }, [slug, language]);

  if (notFound) {
    return (
      <div style={{ 
        maxWidth: 600, 
        margin: "80px auto", 
        padding: "40px 30px", 
        textAlign: "center", 
        border: "1px solid #eee", 
        borderRadius: "12px", 
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.05)",
        fontFamily: "Arial, sans-serif"
      }}>
        <h1 style={{ fontSize: "2rem", color: "#333", marginBottom: "10px" }}>
          {t("not_found_title") || "Page Not Found"}
        </h1>
        <p style={{ color: "#666", fontSize: "1rem", marginBottom: "30px" }}>
          {t("not_found_message") || "The page you are looking for does not exist."}
        </p>
        <a 
          href="/" 
          style={{
            display: "inline-block",
            backgroundColor: "#007BFF",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "bold",
            transition: "background-color 0.2s ease"
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#0056b3"}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#007BFF"}
        >
          {t("go_home") || "Go to Home"}
        </a>
      </div>
    );
  }

  if (!page) return <p>Loading...</p>;

  return (
    <div className="cms-page" style={{ maxWidth: 900, margin: "40px auto", padding: 20 }}>
      <h1 style={{ fontSize: "2.5rem", fontWeight: "700", color: "#222", marginBottom: "1rem", borderBottom: "3px solid #ccc", paddingBottom: "0.5rem", textAlign: "center", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}> {page.title} </h1>
      {slug === "faq" ? (
        <FAQ language={language} useAccordion />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: page.content }} />
      )}
    </div>
  );
};

export default CmsPage;
